import type { FilterType } from '@fiverr-private/listing_types';

export const getPriorityFilterTitle = (filter: FilterType): string => {
    const [firstSelected, ...restSelected] = filter.options.filter((option) => option.selected);

    if (!firstSelected) {
        return filter.alias ?? '';
    }

    return restSelected.length > 0 ? `${firstSelected.alias} +${restSelected.length}` : firstSelected.alias ?? '';
};
